/* import __COLOCATED_TEMPLATE__ from './report-list-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();